import { render, staticRenderFns } from "./GradeRow.vue?vue&type=template&id=d96b5f80&scoped=true&"
import script from "./GradeRow.vue?vue&type=script&lang=js&"
export * from "./GradeRow.vue?vue&type=script&lang=js&"
import style0 from "./GradeRow.vue?vue&type=style&index=0&id=d96b5f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96b5f80",
  null
  
)

export default component.exports